import React, { memo, useCallback } from 'react'
import cx from 'classnames'
import Paper from '@material-ui/core/Paper'
import { dismissPopover } from 'services/OverlayService'

const menuItemCx = 'f5 f6-t f7-m fw6 tracked-cosy no-underline max-w-12 focus-outline-0'

const MenuItem = memo(({ onClick, title, isLogged, url, currentUrl, setSignUpModalIsOpen }) => {
  const accessDenied = (!isLogged && title === 'Analytics')
  const handleOnClick = useCallback((e) => {
    if (accessDenied) {
      dismissPopover(e.target)
      e.preventDefault()
      e.stopPropagation()
      setSignUpModalIsOpen(true)
    } else {
      onClick && onClick(e)
    }
  }, [accessDenied, setSignUpModalIsOpen, onClick])
  const isCurrentUrl = url.split('?')[0] === currentUrl

  return (
    <a
      onClick={handleOnClick}
      href={url}
      className={menuItemCx}
      tabIndex='-1'
      data-event-category='Markets:Menu'
      data-event-action='Navigation'
      data-event-label={`[listdeals][${title}]`}
    >
      <Paper
        className='f7-m mh1 pv4 pv2-m tc nowrap min-w11'
        classes={{
          root: cx('br0 pa0', {
            'active bg-dark-sea-green-3 white': isCurrentUrl,
            'hover-default-tab-button-bg cadet-blue': !isCurrentUrl
          })
        }}
      >
        {title}
      </Paper>
    </a>
  )
})

export default MenuItem
